<template>
  <press-center
      :in-category="2021"
      current-url="Russian sign language"
      in-name="russian-sign-language"
  />
</template>

<script>
import PressCenter from "@/views/PressCenter";
export default {
  name: "PressRussian",
  components: {PressCenter},
  mounted () {
  }
}
</script>

<style scoped>

</style>
